import { Component, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VentanaFlotante } from "../models/VentanaFlotante";

@Component({
  selector: 'ral-siniestro-extra-dialog',
  templateUrl: './siniestro-extra-dialog.component.html',
  styleUrls: ['./siniestro-extra-dialog.component.scss']
})
export class SiniestroExtraDialogComponent extends VentanaFlotante {

  protected form = this.formBuilder.group({
    lugar: [this.data?.lugar || '', Validators.required],
    como: [this.data?.como || '', Validators.required]
  });

  private formularioHojas: any;

  constructor(
    public override dialogRef: MatDialogRef<SiniestroExtraDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: {
      lugar: string,
      como: string,
      formularioHojas: any
    },
    private formBuilder: FormBuilder
  ) {
    super(dialogRef, data);
    this.formularioHojas = data.formularioHojas;
  }

  guardar() {
    if (this.form.invalid) {
      this.formularioHojas.mostrarArgumentario(
        "Atención",
        ["Debes completar todos los campos del siniestro"],
        false,
        true,
        true
      );
      return;
    }

    this.dialogRef.close(this.form.value);
  }

  cerrar() {
    this.dialogRef.close();
  }
}